import { createApiClient } from 'Network/ApiClient';

export const DrugFrequencyRelationAxiosInstance = createApiClient('Drugsfrequency/');


